import React from "react";
import * as PropTypes from 'prop-types';
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import {withStyles} from '@material-ui/core/styles';
import HeatExchangerProcessTableCell from "./HeatExchangerProcessTableCell";
import PlantManagementUtility from "./PlantManagementUtility";
import Utility from "../../Utility";

const styles = theme => ({
    tableTitle: {
        width: theme.spacing.unit,
        padding: theme.spacing.unit / 2,
        fontSize: '1rem'
    },
    tableRow: {
        height: 34
    },
    dialogRoot: {
        textAlign: 'center'
    }
});

class HeatExchangerProcess extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpenDialog: false,
        };

        this.clearCleaningStatus = this.clearCleaningStatus.bind(this);
        this.clearPretestComplete = this.clearPretestComplete.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.onChangeAirBlowComplete = this.onChangeAirBlowComplete.bind(this);
        this.onChangeEtComplete = this.onChangeEtComplete.bind(this);
        this.onChangeFtectComplete = this.onChangeFtectComplete.bind(this);
        this.onChangeIrisComplete = this.onChangeIrisComplete.bind(this);
        this.onChangePretestComplete = this.onChangePretestComplete.bind(this);
    }

    clearCleaningStatus(heatExchanger, paramMapKey) {
        let newHeatExchanger = Utility.getDeepCopy(heatExchanger);
        let paramMap = PlantManagementUtility.CLEANING_RANGE_MAP.get(paramMapKey);
        newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.IS_START)] = '';
        newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.START_DATETIME)] = '';
        newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.IS_STOP)] = '';
        newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_DATETIME)] = '';
        newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_CUMULATIVE_MINUTE)] = '';
        newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.IS_COMPLETE)] = '';
        newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.COMPLETE_DATETIME)] = '';
        newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.WORK_CUMULATIVE_MINUTE)] = '';
        return newHeatExchanger;
    }

    clearPretestComplete() {
        let nowDatetime = Utility.getNowDatetimeString();
        let newHeatExchanger = Utility.getDeepCopy(this.props.heatExchanger);
        // 洗浄範囲（実績　内面　ｶﾞﾝ①）
        newHeatExchanger = this.clearCleaningStatus(newHeatExchanger, PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_GAN1);
        // 洗浄範囲（実績　内面　ｶﾞﾝ②）
        newHeatExchanger = this.clearCleaningStatus(newHeatExchanger, PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_GAN2);
        // 洗浄範囲（実績　内面　ﾌﾚｷ①）
        newHeatExchanger = this.clearCleaningStatus(newHeatExchanger, PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_FLEXI1);
        // 洗浄範囲（実績　内面　ﾌﾚｷ②）
        newHeatExchanger = this.clearCleaningStatus(newHeatExchanger, PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_FLEXI2);
        // 洗浄範囲（実績　内面　装置①）
        newHeatExchanger = this.clearCleaningStatus(newHeatExchanger, PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_EQUIPMENT1);
        // 洗浄範囲（実績　内面　装置②）
        newHeatExchanger = this.clearCleaningStatus(newHeatExchanger, PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_EQUIPMENT2);
        // 洗浄範囲（実績　内面　ﾗﾝｽ①）
        newHeatExchanger = this.clearCleaningStatus(newHeatExchanger, PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_LANCE1);
        // 洗浄範囲（実績　内面　ﾗﾝｽ②）
        newHeatExchanger = this.clearCleaningStatus(newHeatExchanger, PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_LANCE2);
        // 洗浄範囲（実績　外面　ｶﾞﾝ①）
        newHeatExchanger = this.clearCleaningStatus(newHeatExchanger, PlantManagementUtility.CONSTRUCTION_METHOD_KEY.OUTER_GAN1);
        // 洗浄範囲（実績　外面　ｶﾞﾝ②）
        newHeatExchanger = this.clearCleaningStatus(newHeatExchanger, PlantManagementUtility.CONSTRUCTION_METHOD_KEY.OUTER_GAN2);
        // 洗浄範囲（実績　外面　装置①）
        newHeatExchanger = this.clearCleaningStatus(newHeatExchanger, PlantManagementUtility.CONSTRUCTION_METHOD_KEY.OUTER_EQUIPMENT1);
        // 洗浄範囲（実績　外面　装置②）
        newHeatExchanger = this.clearCleaningStatus(newHeatExchanger, PlantManagementUtility.CONSTRUCTION_METHOD_KEY.OUTER_EQUIPMENT2);
        // 洗浄範囲（実績　超高　本数①）
        newHeatExchanger = this.clearCleaningStatus(newHeatExchanger, PlantManagementUtility.CONSTRUCTION_METHOD_KEY.SUPER_HIGH_NUM1);
        // 洗浄範囲（実績　超高　本数②）
        newHeatExchanger = this.clearCleaningStatus(newHeatExchanger, PlantManagementUtility.CONSTRUCTION_METHOD_KEY.SUPER_HIGH_NUM2);
        // 工程（実績）
        newHeatExchanger.resultOfProcessIsCompletePretest = PlantManagementUtility.PARAM_BOOL.FALSE; // 前検（実績）
        newHeatExchanger.resultOfProcessPretestDatetime = ''; // 前検（日時）
        // システム情報
        newHeatExchanger.systemInfoUpdateDate = nowDatetime; // 更新日時

        this.closeDialog();
        this.props.onChangePretestComplete(newHeatExchanger);
    }

    closeDialog() {
        this.setState({isOpenDialog: false});
    }

    onChangeAirBlowComplete() {
        let newHeatExchanger = Utility.getDeepCopy(this.props.heatExchanger);
        let nowDatetimeString = Utility.getNowDatetimeString();
        if (PlantManagementUtility.isParamTrue(this.props.heatExchanger.resultOfProcessIsCompleteAirBlow)) {
            newHeatExchanger.resultOfProcessIsCompleteAirBlow = PlantManagementUtility.PARAM_BOOL.FALSE; // エアブロー（実績）
            newHeatExchanger.resultOfProcessAirBlowDatetime = ''; // エアブロー（日時）
        } else {
            newHeatExchanger.resultOfProcessIsCompleteAirBlow = PlantManagementUtility.PARAM_BOOL.TRUE; // エアブロー（実績）
            newHeatExchanger.resultOfProcessAirBlowDatetime = nowDatetimeString; // エアブロー（日時）
        }
        newHeatExchanger.systemInfoUpdateDate = nowDatetimeString; // 更新日時
        this.props.onChangeAirBlowComplete(newHeatExchanger);
    }

    onChangeEtComplete() {
        let newHeatExchanger = Utility.getDeepCopy(this.props.heatExchanger);
        let nowDatetimeString = Utility.getNowDatetimeString();
        if (PlantManagementUtility.isParamTrue(this.props.heatExchanger.resultOfProcessIsCompleteEt)) {
            newHeatExchanger.resultOfProcessIsCompleteEt = PlantManagementUtility.PARAM_BOOL.FALSE; // ET（実績）
            newHeatExchanger.resultOfProcessEtDatetime = ''; // ET（日時）
        } else {
            newHeatExchanger.resultOfProcessIsCompleteEt = PlantManagementUtility.PARAM_BOOL.TRUE; // ET（実績）
            newHeatExchanger.resultOfProcessEtDatetime = nowDatetimeString; // ET（日時）
        }
        newHeatExchanger.systemInfoUpdateDate = nowDatetimeString; // 更新日時
        this.props.onChangeEtComplete(newHeatExchanger);
    }

    onChangeFtectComplete() {
        let newHeatExchanger = Utility.getDeepCopy(this.props.heatExchanger);
        let nowDatetimeString = Utility.getNowDatetimeString();
        if (PlantManagementUtility.isParamTrue(this.props.heatExchanger.resultOfProcessIsCompleteFtect)) {
            newHeatExchanger.resultOfProcessIsCompleteFtect = PlantManagementUtility.PARAM_BOOL.FALSE; // FTECT（実績）
            newHeatExchanger.resultOfProcessFtectDatetime = ''; // FTECT（日時）
        } else {
            newHeatExchanger.resultOfProcessIsCompleteFtect = PlantManagementUtility.PARAM_BOOL.TRUE; // FTECT（実績）
            newHeatExchanger.resultOfProcessFtectDatetime = nowDatetimeString; // FTECT（日時）
        }
        newHeatExchanger.systemInfoUpdateDate = nowDatetimeString; // 更新日時
        this.props.onChangeFtectComplete(newHeatExchanger);
    }

    onChangeIrisComplete() {
        let newHeatExchanger = Utility.getDeepCopy(this.props.heatExchanger);
        let nowDatetimeString = Utility.getNowDatetimeString();
        if (PlantManagementUtility.isParamTrue(this.props.heatExchanger.resultOfProcessIsCompleteIris)) {
            newHeatExchanger.resultOfProcessIsCompleteIris = PlantManagementUtility.PARAM_BOOL.FALSE; // IRIS（実績）
            newHeatExchanger.resultOfProcessIrisDatetime = ''; // IRIS（日時）
        } else {
            newHeatExchanger.resultOfProcessIsCompleteIris = PlantManagementUtility.PARAM_BOOL.TRUE; // IRIS（実績）
            newHeatExchanger.resultOfProcessIrisDatetime = nowDatetimeString; // IRIS（日時）
        }
        newHeatExchanger.systemInfoUpdateDate = nowDatetimeString; // 更新日時
        this.props.onChangeIrisComplete(newHeatExchanger);
    }

    onChangePretestComplete() {
        if (PlantManagementUtility.isParamTrue(this.props.heatExchanger.resultOfProcessIsCompletePretest)) {
            // ON -> OFF時はダイアログ表示.
            this.setState({isOpenDialog: true});
        } else {
            let nowDatetime = Utility.getNowDatetimeString();
            let newHeatExchanger = Utility.getDeepCopy(this.props.heatExchanger);
            newHeatExchanger.resultOfProcessIsCompletePretest = PlantManagementUtility.PARAM_BOOL.TRUE; // 前検（実績）
            newHeatExchanger.resultOfProcessPretestDatetime = nowDatetime; // 前検（日時）
            newHeatExchanger.systemInfoUpdateDate = nowDatetime; // 更新日時
            this.props.onChangePretestComplete(newHeatExchanger);
        }
    }

    render() {
        const {classes, heatExchanger} = this.props;
        return (
            <div>
                <Table>
                    <TableBody>
                        <TableRow className={classes.tableRow}>
                            <TableCell size={'small'} rowSpan={2} className={classes.tableTitle}>{'工程'}</TableCell>
                            <HeatExchangerProcessTableCell
                                headerLabel={'前検'}
                                resultOfProcessIsComplete={heatExchanger.resultOfProcessIsCompletePretest}
                                isDisable={false}
                                resultOfProcessDatetime={heatExchanger.resultOfProcessPretestDatetime}
                                onChange={this.onChangePretestComplete}
                            />
                            <HeatExchangerProcessTableCell
                                headerLabel={'ｴｱﾌﾞﾛｰ'}
                                resultOfProcessIsComplete={heatExchanger.resultOfProcessIsCompleteAirBlow}
                                isDisable={!PlantManagementUtility.isPlanedProcess(heatExchanger.systemInfoAdditionalFlag, heatExchanger.planOfProcessAirBlow,)}
                                resultOfProcessDatetime={heatExchanger.resultOfProcessAirBlowDatetime}
                                onChange={this.onChangeAirBlowComplete}
                            />
                            <HeatExchangerProcessTableCell
                                headerLabel={'ET'}
                                resultOfProcessIsComplete={heatExchanger.resultOfProcessIsCompleteEt}
                                isDisable={!PlantManagementUtility.isPlanedProcess(heatExchanger.systemInfoAdditionalFlag, heatExchanger.planOfProcessEt)}
                                resultOfProcessDatetime={heatExchanger.resultOfProcessEtDatetime}
                                onChange={this.onChangeEtComplete}
                            />
                        </TableRow>
                        <TableRow className={classes.tableRow}>
                            <HeatExchangerProcessTableCell
                                headerLabel={'FTECT'}
                                resultOfProcessIsComplete={heatExchanger.resultOfProcessIsCompleteFtect}
                                isDisable={!PlantManagementUtility.isPlanedProcess(heatExchanger.systemInfoAdditionalFlag, heatExchanger.planOfProcessFtect)}
                                resultOfProcessDatetime={heatExchanger.resultOfProcessFtectDatetime}
                                onChange={this.onChangeFtectComplete}
                            />
                            <HeatExchangerProcessTableCell
                                headerLabel={'IRIS'}
                                resultOfProcessIsComplete={heatExchanger.resultOfProcessIsCompleteIris}
                                isDisable={!PlantManagementUtility.isPlanedProcess(heatExchanger.systemInfoAdditionalFlag, heatExchanger.planOfProcessIris)}
                                resultOfProcessDatetime={heatExchanger.resultOfProcessIrisDatetime}
                                onChange={this.onChangeIrisComplete}
                            />
                            <TableCell/>
                        </TableRow>
                    </TableBody>
                </Table>
                <Dialog open={this.state.isOpenDialog} onClose={this.closeDialog} className={classes.dialogRoot}>
                    <DialogTitle>前検完了のクリア</DialogTitle>
                    <DialogContent>
                        <DialogContentText>洗浄範囲の完了時間をクリアします。入力内容が破棄されます。よろしいですか？</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button fullWidth onClick={this.closeDialog} color="secondary" variant="contained">いいえ</Button>
                        <Button fullWidth onClick={this.clearPretestComplete} color="primary" variant="contained">はい</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

HeatExchangerProcess.propTypes = {
    heatExchanger: PropTypes.object.isRequired,
    onChangeAirBlowComplete: PropTypes.func.isRequired,
    onChangeEtComplete: PropTypes.func.isRequired,
    onChangeFtectComplete: PropTypes.func.isRequired,
    onChangeIrisComplete: PropTypes.func.isRequired,
    onChangePretestComplete: PropTypes.func.isRequired
};

export default withStyles(styles)(HeatExchangerProcess);
